<template>
  <validation-observer v-slot="{ handleSubmit }">
    <form
      class="registration-form"
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <validation-provider
        v-slot="{ errors }"
        name="Имя"
        rules="alpha|min:3|max:20|required"
      >
        <app-input
          v-model="personInformation.name"
          placeholder="Ваше имя"
          class="registration-form__input"
          icon="IconUser"
          name="userName"
          type="text"
        />
        <span class="error">{{ errors[0] }}</span>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="Фамилия"
        rules="alpha|min:3|max:20|required"
      >
        <app-input
          v-model="personInformation.surname"
          placeholder="Ваша фамилия"
          class="registration-form__input"
          icon="IconUser"
          name="userSurname"
          type="text"
        />
        <span class="error">{{ errors[0] }}</span>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="Группа"
        rules="required"
      >
        <app-select
          v-model="personInformation.group_person"
          class="registration-form__select"
          :options="persons"
          :width="300"
          icon="Вы"
          placeholder="Выбрать"
        />
        <span class="error">{{ errors[0] }}</span>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="e-mail"
        rules="email|required"
      >
        <app-input
          v-model="personInformation.email"
          placeholder="Ваш e-mail"
          class="registration-form__input"
          icon="IconEmail"
          name="userEmail"
          type="email"
        />
        <span class="error">{{ errors[0] }}</span>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="Телефон"
        :rules="'required'"
      >
        <app-input
          v-model="personInformation.phone"
          v-mask="'XXXXXXXXXXXXXX'"
          placeholder="Ваш телефон"
          class="registration-form__input"
          icon="IconPhone"
          name="userPhone"
        />
        <span class="error">{{ errors[0] }}</span>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="Класс"
        rules="required"
      >
        <app-select
          v-model="personInformation.grade"
          class="registration-form__select"
          :options="grades"
          icon="Кл."
          :width="300"
          placeholder="Выбрать"
        />
        <span class="error">{{ errors[0] }}</span>
      </validation-provider>

      <app-button
        type="submit"
        class="registration-form__button"
      >
        Зарегистрироваться
      </app-button>
      <small
        class="registration-form__text"
      >
        Оставляя заявку, вы даете согласие на <br>
        <a
          href="https://maximumtest.ru/personal-data"
          class="registration-form__link"
        >
          обработку персональных данных
        </a>
      </small>
    </form>
  </validation-observer>
</template>

<script>
import AppInput from '../Base/AppInput';
import AppSelect from '../Base/AppSelect';
import AppButton from '../Base/AppButton';

export default {
  name: 'RegistrationForm',
  components: {
    AppInput,
    AppSelect,
    AppButton,
  },
  data() {
    return {
      grades: ['11', '10', '9', '8', '7', '6', '5'],
      persons: ['Родитель', 'Ученик'],
      personInformation: {
        name: '',
        surname: '',
        phone: '',
        email: '',
        grade: '',
        group_person: '',
        gaCid: '',
      },
    };
  },
  methods: {
    async onSubmit() {
      try {
        const gaCidContainer = document.getElementById('ga_cid');
        const gaCid = gaCidContainer ? gaCidContainer.value : '';
        localStorage.setItem('ga_cid', gaCid);
        const response = await this.$axios.post('/registration', { ...this.personInformation, gaCid });
        localStorage.setItem('user_id', response.data.id);
        await this.$router.push('/beginning');
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .registration-form {
    width: 300px;
    display: flex;
    flex-direction: column;
    padding: 0 0 10px 0;
    &__input, &__select, &__button {
      margin: 11px 0 ;
    }
    &__text {
      font-family: 'Open Sans','sans-serif';
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 18px;
      color: #9F9F9F;
    }
    &__link{
      color: #9F9F9F;
    }
  }

  .radio-button {
    display: inline-flex;
      &__title {
        font-size: 18px;
        font-weight: bold;
        padding: 0;
        margin: 0;
    }
  }

  .error {
    color: rgb(212, 0, 0);
    font-weight: bold;
  }

  @media (max-width: 576px) {
    .registration-form {
      width: auto;
      &__input, &__select {
        width: 100%;
      };
    }
    .radio-button {
      flex-direction: column;
      &__title {
        text-align: left;
        padding-left: 15px;
      }
    }
  }
</style>
